export const ERROR_KEY_TERMS = 'new_tnc';
export const LOGGED_IN_USER_STATUS = 'loggedIn';

export enum USER_PHASES {
    inShop = 'in-shop',
    preRegistered = 'pre-registered',
    online = 'online',
    multiChannel = 'multi-channel',
}
